<form [formGroup]="form" class="border">
	<!-- Date -->
	<div class="mx-3 mt-3">
		<span class="fg-grey">{{ locale.translations['ads']['filter']['n109'] }}</span>
		 <div
			class="d-flex items-center n743 justify-between bg-white h-[45px] w-full sm:w-[250px] px-3 cursor-pointer transition mb-4 border rounded"
			(click)="picker.open()"
		>
			<input
				matInput
				[matDatepicker]="picker"
				readonly
				formControlName="date"
				(dateChange)="onDateSelection()"
				[max]="maxDate"
				placeholder="{{ locale.translations['n743'] }}"
				i18n-placeholder="@@filter_by_date_label"
				class="w-full bg-transparent focus:outline-none cursor-pointer"
  				style="font-weight: 400; font-size: 16px; color: #000 !important;"
			/>

			<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-datepicker dir="ltr" #picker></mat-datepicker>
    	</div>
	</div>
	<mat-divider class="py-0 my-0"></mat-divider>

	<!-- location -->
	<div class="mx-3 mt-3">
		<span class="fg-grey">{{ locale.translations['ads']['filter']['n25'] }}</span>
		<mat-form-field appearance="outline" class="n25 v2" (click)="autoFocus(true)">
			<mat-select
				placeholder="{{ locale.translations['ads']['filter']['n25'] }}"
				formControlName="location"
				(closed)="onClearSearch(searchTextLocation)"
				(selectionChange)="onFilterSelected('location')"
				multiple
			>
				<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
					<input
						matInput
						type="text"
						id="searchbox"
						[formControl]="searchTextLocation"
						placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n25'] }}"
					/>
				</mat-form-field>

				<mat-option class="border-bottom" *ngIf="!searchTextLocation.value" value="">
					{{ locale.translations['ads']['filter']['n23'] }}
				</mat-option>

				<!-- popular locations -->
				<mat-option
					class="bg-white border-bottom"
					*ngFor="let location of popularLocations | filterText : searchTextLocation.value"
					value="{{ location['id'] }}"
				>
					{{ location['name'] }}
				</mat-option>

				<!-- divider -->
				<mat-divider style="margin: 0"></mat-divider>

				<!-- all locations -->
				<mat-option
					class="bg-white border-bottom"
					*ngFor="let location of locations | filterText : searchTextLocation.value"
					value="{{ location['id'] }}"
				>
					{{ location['name'] }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<mat-divider class="py-0 my-0"></mat-divider>

	<!-- <div class="row mb-5px" *ngIf="(user && user['userType'] !== '1') || !user">
		<div class="col-12 fg-grey mb-2">
			{{ locale.translations['place-ad']['category']['n57'] }}
		</div>
		<div class="col-12">
			<mat-form-field appearance="outline" class="v2 fs-14px" hideRequiredMarker (click)="autoFocus()">
				<mat-select
					required
					placeholder="{{ locale.translations['place-ad']['n480'] }} {{ locale.translations['place-ad']['category']['n58'] }}"
					(selectionChange)="onCategorySelection($event)"
					(closed)="onClearSearch(searchTextCat)"
					formControlName="category"
				>
					<mat-form-field appearance="standard" class="search-field">
						<input
							matInput
							type="text"
							[formControl]="searchTextCat"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['place-ad']['category']['n58'] }}"
						/>
					</mat-form-field>
					<mat-option *ngFor="let category of categories | filterText : searchTextCat.value" value="{{ category['id'] }}">
						{{ category['name'] }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="form.controls.category.hasError('required')">
					{{ locale.translations['place-ad']['category']['n58'] }} {{ locale.translations['payment']['n421'] }}
				</mat-error>
			</mat-form-field>
		</div>
	</div> -->

	<!-- category -->
	<div class="mx-3 mt-3">
		<span class="fg-grey">{{ locale.translations['place-ad']['category']['n58'] }}</span>
		<mat-form-field appearance="outline" class="n59 v2 w-100" (click)="autoFocus()">
			<mat-select
				formControlName="catID"
				placeholder="{{ locale.translations['place-ad']['category']['n58'] }}"
				(selectionChange)="onCategorySelection($event)"
				(closed)="onClearSearch(searchTextCat)"
			>
				<mat-select-trigger>
					<div class="mat-select-trigger-content">
						{{ form.get('catID').value | selectedFilterName : categories : locale.translations['ads']['filter']['n23'] }}
					</div>
				</mat-select-trigger>
				<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
					<input
						matInput
						type="text"
						[formControl]="searchTextCat"
						id="searchbox"
						placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['place-ad']['category']['n58'] }}"
					/>
				</mat-form-field>
				<mat-option class="bg-white border-bottom" *ngFor="let category of categories | filterText : searchTextCat.value" value="{{ category['id'] }}">
					<div class="option-content">
						<span>{{ category['name'] }}</span>
						<mat-icon *ngIf="category['id'] === form.get('catID').value" class="mx-0 fs-20px">check</mat-icon>
					</div>
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<mat-divider class="py-0 my-0"></mat-divider>

	<!-- subcategory -->
	<div class="mx-3 mt-3">
		<span class="fg-grey">{{ locale.translations['place-ad']['category']['n59'] }}</span>
		<mat-form-field appearance="outline" class="n59 v2" (click)="autoFocus()">
			<mat-select
				formControlName="subCatID"
				placeholder="{{ locale.translations['place-ad']['category']['n59'] }}"
				(selectionChange)="onSubcategorySelection($event)"
				(closed)="onClearSearch(searchTextSubCat)"
			>
				<mat-select-trigger>
					{{ form.get('subCatID').value | selectedFilterName : subcategories : locale.translations['ads']['filter']['n23'] }}
				</mat-select-trigger>
				<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
					<input
						matInput
						type="text"
						[formControl]="searchTextSubCat"
						id="searchbox"
						placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['place-ad']['category']['n59'] }}"
					/>
				</mat-form-field>
				<mat-option class="border-bottom" *ngIf="!searchTextSubCat.value" value="">
					<div class="option-content">
						{{ locale.translations['ads']['filter']['n23'] }}
						<mat-icon *ngIf="form.get('subCatID').value === ''" class="mx-0 fs-20px">check</mat-icon>
					</div>
				</mat-option>
				<mat-option
					class="bg-white border-bottom"
					*ngFor="let subcategory of subcategories | filterText : searchTextSubCat.value"
					value="{{ subcategory['id'] }}"
				>
					<div class="option-content">
						{{ subcategory['name'] }}
						<mat-icon *ngIf="subcategory['id'] === form.get('subCatID').value" class="mx-0 fs-20px">check</mat-icon>
					</div>
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<mat-divider class="py-0 my-0"></mat-divider>

	<!-- //electronics data (brand,model,color) -->
	<ng-container
		*ngIf="
			catID === '16' &&
			(form.get('subCatID').value === '302' ||
				form.get('subCatID').value === '303' ||
				form.get('subCatID').value === '304' ||
				form.get('subCatID').value === '305' ||
				form.get('subCatID').value === '306' ||
				form.get('subCatID').value === '307' ||
				form.get('subCatID').value === '308' ||
				form.get('subCatID').value === '309' ||
				form.get('subCatID').value === '310' ||
				form.get('subCatID').value === '311' ||
				form.get('subCatID').value === '312' ||
				form.get('subCatID').value === '313' ||
				form.get('subCatID').value === '365' ||
				form.get('subCatID').value === '366' ||
				form.get('subCatID').value === '367' ||
				form.get('subCatID').value === '370' ||
				form.get('subCatID').value === '371' ||
				form.get('subCatID').value === '372' ||
				form.get('subCatID').value === '373')
		"
	>
		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n271'] }}</span>
			<mat-form-field appearance="outline" class="n271 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }}  {{ locale.translations['ads']['filter']['n271'] }}"
					(selectionChange)="onBrandSelection($event['value'])"
					(closed)="onClearSearch(searchTextBrand)"
					formControlName="electronicBrandID"
				>
					<mat-select-trigger>
						{{ form.get('electronicBrandID').value | selectedFilterName : electronicData['brands'] : locale.translations['ads']['filter']['n23'] }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextBrand"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n271'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextBrand.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicBrandID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let brand of electronicData['brands'] | filterText : searchTextBrand.value"
						value="{{ brand['id'] }}"
					>
						<div class="option-content">
							{{ brand['name'] }}
							<mat-icon *ngIf="brand['id'] === form.get('electronicBrandID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
				<!-- <mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">security</mat-icon> -->
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>

		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n27'] }}</span>
			<mat-form-field appearance="outline" class="n27 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }}  {{ locale.translations['ads']['filter']['n27'] }}"
					formControlName="electronicModelID"
					(closed)="onClearSearch(searchTextModel)"
				>
					<mat-select-trigger>
						{{ form.get('electronicModelID').value | selectedFilterName : models : locale.translations['ads']['filter']['n23'] }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextModel"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n27'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextModel.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicModelID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option class="bg-white border-bottom" *ngFor="let model of models | filterText : searchTextModel.value" value="{{ model['id'] }}">
						<div class="option-content">
							{{ model['name'] }}
							<mat-icon *ngIf="model['id'] === form.get('electronicModelID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
				<!-- <mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">layers</mat-icon> -->
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>

		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n31'] }}</span>
			<mat-form-field appearance="outline" class="n31 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }}  {{ locale.translations['ads']['filter']['n31'] }}"
					formControlName="electronicColorID"
					(closed)="onClearSearch(searchTextColor)"
				>
					<mat-select-trigger>
						{{ form.get('electronicColorID').value | selectedFilterName : electronicData['colors'] : locale.translations['ads']['filter']['n23'] }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							id="searchbox"
							[formControl]="searchTextColor"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n31'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextColor.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicColorID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let color of electronicData['colors'] | filterText : searchTextColor.value"
						value="{{ color['id'] }}"
					>
						<div class="option-content">
							{{ color['name'] }}
							<mat-icon *ngIf="color['id'] === form.get('electronicColorID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
				<!-- <mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">color_lens</mat-icon> -->
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>
	</ng-container>
	<!-- STORAGE -->
	<ng-container
		*ngIf="
			catID === '16' &&
			(form.get('subCatID').value === '302' ||
				form.get('subCatID').value === '303' ||
				form.get('subCatID').value === '304' ||
				form.get('subCatID').value === '305' ||
				form.get('subCatID').value === '306' ||
				form.get('subCatID').value === '311')
		"
	>
		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n272'] }}</span>
			<mat-form-field appearance="outline" class="n272 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }}  {{ locale.translations['ads']['filter']['n272'] }} "
					formControlName="electronicStorageID"
					(closed)="onClearSearch(searchTextStorage)"
				>
					<mat-select-trigger>
						{{
							form.get('electronicStorageID').value | selectedFilterName : electronicData['storage'] : locale.translations['ads']['filter']['n23']
						}}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							id="searchbox"
							[formControl]="searchTextStorage"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n272'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextStorage.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicStorageID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let storage of electronicData['storage'] | filterText : searchTextStorage.value"
						value="{{ storage['id'] }}"
					>
						<div class="option-content">
							{{ storage['name'] }}
							<mat-icon *ngIf="storage['id'] === form.get('electronicStorageID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
				<!-- <mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">storage</mat-icon> -->
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>
	</ng-container>

	<!-- MEMORY -->
	<ng-container *ngIf="catID === '16' && (form.get('subCatID').value === '304' || form.get('subCatID').value === '305')">
		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n273'] }}</span>
			<mat-form-field appearance="outline" class="n273 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['ads']['filter']['n273'] }}"
					formControlName="electronicMemoryID"
					(closed)="onClearSearch(searchTextMemory)"
				>
					<mat-select-trigger>
						{{ form.get('electronicMemoryID').value | selectedFilterName : electronicData['memory'] : locale.translations['ads']['filter']['n23'] }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							id="searchbox"
							[formControl]="searchTextMemory"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n273'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextMemory.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicMemoryID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let memory of electronicData['memory'] | filterText : searchTextMemory.value"
						value="{{ memory['id'] }}"
					>
						<div class="option-content">
							{{ memory['name'] }}
							<mat-icon *ngIf="memory['id'] === form.get('electronicMemoryID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
				<!-- <mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">memory</mat-icon> -->
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>

		<!-- PROCESSOR -->
		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n275'] }}</span>
			<mat-form-field appearance="outline" class="n275 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['ads']['filter']['n275'] }}"
					formControlName="electronicProcessorID"
					(closed)="onClearSearch(searchTextProcessor)"
				>
					<mat-select-trigger>
						{{
							form.get('electronicProcessorID').value
								| selectedFilterName : electronicData['processor'] : locale.translations['ads']['filter']['n23']
						}}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextProcessor"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n275'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextProcessor.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicProcessorID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let processor of electronicData['processor'] | filterText : searchTextProcessor.value"
						value="{{ processor['id'] }}"
					>
						<div class="option-content">
							{{ processor['name'] }}
							<mat-icon *ngIf="processor['id'] === form.get('electronicProcessorID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
				<!-- <mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">select_all</mat-icon> -->
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>

		<!-- GRAPHICS -->

		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n276'] }}</span>
			<mat-form-field appearance="outline" class="n276 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['ads']['filter']['n276'] }}"
					formControlName="electronicGraphicsID"
					(closed)="onClearSearch(searchTextGraphics)"
				>
					<mat-select-trigger>
						{{
							form.get('electronicGraphicsID').value
								| selectedFilterName : electronicData['graphics'] : locale.translations['ads']['filter']['n23']
						}}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextGraphics"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n276'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextGraphics.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicGraphicsID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let graphics of electronicData['graphics'] | filterText : searchTextGraphics.value"
						value="{{ graphics['id'] }}"
					>
						<div class="option-content">
							{{ graphics['name'] }}
							<mat-icon *ngIf="graphics['id'] === form.get('electronicGraphicsID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
				<!-- <mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">video_settings</mat-icon> -->
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>
	</ng-container>

	<!-- Network  -->
	<ng-container *ngIf="catID === '16' && (form.get('subCatID').value === '302' || form.get('subCatID').value === '303')">
		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n274'] }}</span>
			<mat-form-field appearance="outline" class="n274 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['place-ad']['category']['n59'] }}"
					formControlName="electronicNetworkID"
					(closed)="onClearSearch(searchTextNetwork)"
				>
					<mat-select-trigger>
						{{
							form.get('electronicNetworkID').value | selectedFilterName : electronicData['network'] : locale.translations['ads']['filter']['n23']
						}}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextNetwork"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['place-ad']['category']['n59'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextNetwork.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('electronicNetworkID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let network of electronicData['network'] | filterText : searchTextNetwork.value"
						value="{{ network['id'] }}"
					>
						<div class="option-content">
							{{ network['name'] }}
							<mat-icon *ngIf="network['id'] === form.get('electronicNetworkID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>
	</ng-container>

	<!-- car data -->
	<ng-container *ngIf="catID === '15' && form.get('subCatID').value === '291'">
		<div class="mx-3 mt-3">
			<!-- <mat-form-field
				appearance="outline"
				class="n26 v2"
				[ngStyle]="{ padding: locale.lang === 'en' ? '0 0.5em 0 0' : '0 0 0 0.5em' }"
				(click)="autoFocus()"
			> -->
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n26'] }}</span>
			<mat-form-field appearance="outline" class="n26 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['ads']['filter']['n26'] }}"
					(selectionChange)="onMakeSelection($event['value'])"
					(closed)="onClearSearch(searchTextMake)"
					formControlName="makeID"
				>
					<mat-select-trigger>
						{{ form.get('makeID').value | selectedFilterName : motorData['makes'] : locale.translations['ads']['filter']['n23'] }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextMake"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n26'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextMake.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('makeID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let make of motorData['makes'] | filterText : searchTextMake.value"
						value="{{ make['id'] }}"
					>
						<div class="option-content">
							{{ make['name'] }}
							<mat-icon *ngIf="make['id'] === form.get('makeID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<mat-divider class="py-0 my-0"></mat-divider>

		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n27'] }}</span>
			<mat-form-field appearance="outline" class="n27 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['ads']['filter']['n27'] }}"
					formControlName="modelID"
					(closed)="onClearSearch(searchTextModel)"
				>
					<mat-select-trigger>
						{{ form.get('modelID').value | selectedFilterName : models : locale.translations['ads']['filter']['n23'] }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextModel"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n27'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextModel.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('modelID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option class="bg-white border-bottom" *ngFor="let model of models | filterText : searchTextModel.value" value="{{ model['id'] }}">
						<div class="option-content">
							{{ model['name'] }}
							<mat-icon *ngIf="model['id'] === form.get('modelID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<mat-divider class="py-0 my-0"></mat-divider>

		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n28'] }}</span>
			<mat-form-field appearance="outline" class="n28 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['ads']['filter']['n28'] }}"
					formControlName="year"
					(closed)="onClearSearch(searchTextYear)"
				>
					<mat-select-trigger>
						{{ form.get('year').value | selectedFilterName : motorData['years'] : locale.translations['ads']['filter']['n23'] : 'year' }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							[formControl]="searchTextYear"
							id="searchbox"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n28'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextYear.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('year').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option class="bg-white border-bottom" *ngFor="let year of motorData['years'] | filterText : searchTextYear.value" value="{{ year }}">
						<div class="option-content">
							{{ year }}
							<mat-icon *ngIf="year === form.get('year').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<mat-divider class="py-0 my-0"></mat-divider>

		<div class="mx-3 mt-3">
			<span class="fg-grey">{{ locale.translations['ads']['filter']['n31'] }}</span>
			<mat-form-field appearance="outline" class="n31 v2" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['n741'] }} {{ locale.translations['ads']['filter']['n31'] }}"
					formControlName="colorID"
					(closed)="onClearSearch(searchTextColor)"
				>
					<mat-select-trigger>
						{{ form.get('colorID').value | selectedFilterName : motorData['color'] : locale.translations['ads']['filter']['n23'] }}
					</mat-select-trigger>

					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							id="searchbox"
							[formControl]="searchTextColor"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n31'] }}"
						/>
					</mat-form-field>
					<mat-option class="border-bottom" *ngIf="!searchTextColor.value" value="">
						<div class="option-content">
							{{ locale.translations['ads']['filter']['n23'] }}
							<mat-icon *ngIf="form.get('colorID').value === ''" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let color of motorData['color'] | filterText : searchTextColor.value"
						value="{{ color['id'] }}"
					>
						<div class="option-content">
							{{ color['name'] }}
							<mat-icon *ngIf="color['id'] === form.get('colorID').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<mat-divider class="py-0 my-0"></mat-divider>
	</ng-container>

	<!-- Price filter div -->

	<div class="mt-3 mx-3">
		<div class="fg-grey">{{ locale.translations['pricing']['n188'] }}</div>
		<div class="d-flex">
			<mat-form-field class="v2 w-50 mx-1" appearance="outline" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['ads']['filter']['n424'] }}"
					formControlName="minPrice"
					(closed)="onClearSearch(searchTextMinPrice)"
					(selectionChange)="onFilterSelected()"
				>
					<mat-select-trigger>
						{{ form.get('minPrice').value }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							id="searchbox"
							[formControl]="searchTextMinPrice"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n424'] }}"
						/>
					</mat-form-field>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let price of priceFilterData['min'] | filterText : searchTextMinPrice.value"
						[value]="price"
					>
						<div class="option-content">
							{{ price }}
							<mat-icon *ngIf="price === form.get('minPrice').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="v2 w-50 mx-1" appearance="outline" (click)="autoFocus()">
				<mat-select
					placeholder="{{ locale.translations['ads']['filter']['n425'] }}"
					formControlName="maxPrice"
					(closed)="onClearSearch(searchTextMaxPrice)"
					(selectionChange)="onFilterSelected()"
				>
					<mat-select-trigger>
						{{ form.get('maxPrice').value }}
					</mat-select-trigger>
					<mat-form-field class="search-field v2 mt-3 border-bottom" appearance="outline">
						<input
							matInput
							type="text"
							id="searchbox"
							[formControl]="searchTextMaxPrice"
							placeholder="{{ locale.translations['ads']['filter']['n290'] }} {{ locale.translations['ads']['filter']['n425'] }}"
						/>
					</mat-form-field>
					<mat-option
						class="bg-white border-bottom"
						*ngFor="let price of priceFilterData['max'] | filterText : searchTextMaxPrice.value"
						[value]="price"
					>
						<div class="option-content">
							{{ price }}
							<mat-icon *ngIf="price === form.get('maxPrice').value" class="mx-0 fs-20px">check</mat-icon>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>

	<mat-divider class="py-0 my-0"></mat-divider>

	<!-- <mat-form-field appearance="outline" class="n32">
		<mat-label class="n32-1">{{ locale.translations['ads']['filter']['n32']['n32-1'] }}</mat-label>
		<mat-select formControlName="order" (selectionChange)="onFilterSelected()">
			<mat-option value="">{{ locale.translations['ads']['filter']['n23'] }}</mat-option>
			<mat-option value="1" class="n32-2">{{ locale.translations['ads']['filter']['n32']['n32-2'] }}</mat-option>
			<mat-option value="0" class="n32-3">{{ locale.translations['ads']['filter']['n32']['n32-3'] }}</mat-option>
			<mat-option value="2" class="n32-3">{{ locale.translations['ads']['filter']['n32']['n427'] }}</mat-option>
			<mat-option value="3" class="n32-3">{{ locale.translations['ads']['filter']['n32']['n426'] }}</mat-option>
		</mat-select>
	</mat-form-field> -->

	<!-- <input matInput [matDatepicker]="datepicker" (dateChange)="onDateSelection($event['value'])" formControlName="date" hidden />
	<mat-datepicker dir="ltr" touchUi #datepicker></mat-datepicker>
	<button type="button" (click)="datepicker.open()" class="datepicker n109">
		<span>{{ form.get('date').value !== null ? selectedDate : locale.translations['ads']['filter']['n109'] }}</span>
		<span class="fill-space"></span>
		<mat-icon [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'end' : null }">date_range</mat-icon>
	</button> -->
	<div class="d-flex my-3 mx-3">
		<button
			mat-flat-button
			[disabled]="!hasSelection"
			(click)="onReset()"
			id="apply-btn"
			[ngClass]="{ 'fg-grey': !hasSelection, 'fg-purple': hasSelection }"
			class="n33 mx-1 bg-white"
		>
			{{ locale.translations['n738'] }}
		</button>
		<button
			*ngIf="!filtered || (form.dirty && filtered)"
			(click)="onSubmit()"
			[disabled]="!hasSelection"
			mat-flat-button
			type="submit"
			color="primary"
			id="apply-btn"
			class="n33 mx-1"
		>
			{{ locale.translations['ads']['filter']['n33']['n33-1'] }}
		</button>
	</div>
</form>
